import React from "react";
import "./InfoDetails.css";
import { Link } from "react-router-dom";

const InfoRol = () => {
  return (
    <div className="info-detail">
      <div className="info-hero roles">
        <h2>Roles y permisos</h2>
        <p>
          El sistema utiliza un esquema de roles para garantizar seguridad y
          claridad en las responsabilidades de cada usuario.
        </p>
      </div>

      <section className="info-section">
        <h3>Tipos de roles</h3>
        <ul>
          <li><b>Admin Master</b>: acceso total, gestiona admins y parámetros globales.</li>
          <li><b>Admin</b>: puede crear usuarios, cargar informes, supervisar operaciones, proyectos.</li>
          <li><b>Manager</b>: supervisa operaciones, proyectos.</li>
          <li><b>Editor</b>: carga y modifica datos de facturas.</li>
          <li><b>Technical</b>: configuración técnica de equipos e instalaciones.</li>
          <li><b>Viewer</b>: acceso de solo lectura.</li>
        </ul>
      </section>

      <section className="info-section alt">
        <h3>Gestión de usuarios</h3>
        <p>
          Solo los roles <b>Admin Master</b> y <b>Admin</b> pueden crear usuarios nuevos.
          El resto de roles se asigna según la necesidad operativa de cada planta.
        </p>
      </section>

      <section className="info-flow">
        <h3>Flujo de creación de usuarios</h3>
        <ol>
          <li>Un <b>Admin Master </b> o <b>Admin</b> accede al panel de gestión de usuarios.</li>
          <li>Completa el formulario de registro con los datos del nuevo usuario. Asignar el <b>rol</b> según las responsabilidades que le quiera dar.</li>
          <li>Vincular el <b>nivel de planta</b> que corresponda (sucursal, área, sector o local).</li>
          <li>El usuario recibe acceso limitado a los módulos habilitados para su rol.</li>
        </ol>
      </section>

      <div className="info-cta">
        <h4>¿Listo para asignar roles?</h4>
        <Link to="/admin/lists?show=users" className="cta-button">
          Gestionar usuarios
        </Link>
      </div>
    </div>
  );
};

export default InfoRol;
